/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
Command: npx gltfjsx@6.2.18 vintage_living_room.glb --transform 
Files: vintage_living_room.glb [13.41MB] > C:\Users\Pareekshit Joshi\Desktop\0xhome models\vintage_living_room-transformed.glb [851.14KB] (94%)
Author: QuarizonStudio (https://sketchfab.com/QuarizonStudio)
License: CC-BY-4.0 (http://creativecommons.org/licenses/by/4.0/)
Source: https://sketchfab.com/3d-models/vintage-living-room-3ac5d18326e24a1ab47279466e4e00ad
Title: vintage living room
*/

import React, { useRef } from 'react'
import { useGLTF } from '@react-three/drei'

export function Model(props) {
  const { nodes, materials } = useGLTF('/vintage_living_room-transformed.glb')
  return (
    <group {...props} dispose={null}>
      <mesh geometry={nodes.sofa_sofa1001_0.geometry} material={materials['sofa1.001']} rotation={[-Math.PI / 2, 0, 0]} />
      <mesh geometry={nodes.sofa_sofa2001_0.geometry} material={materials['sofa2.001']} rotation={[-Math.PI / 2, 0, 0]} />
      <mesh geometry={nodes.carpet_Carpet001_0.geometry} material={materials['Carpet.001']} rotation={[-Math.PI / 2, 0, 0]} />
      <mesh geometry={nodes.floor_Floor001_0.geometry} material={materials['Floor.001']} rotation={[-Math.PI / 2, 0, 0]} />
      <mesh geometry={nodes.table_table1001_0.geometry} material={materials['table1.001']} rotation={[-Math.PI / 2, 0, 0]} />
      <mesh geometry={nodes.table_table2001_0.geometry} material={materials['table2.001']} rotation={[-Math.PI / 2, 0, 0]} />
      <mesh geometry={nodes.wall_wall001_0.geometry} material={materials['wall.001']} rotation={[-Math.PI / 2, 0, 0]} />
      <mesh geometry={nodes.light_light1001_0.geometry} material={materials['light1.001']} rotation={[-Math.PI / 2, 0, 0]} />
      <mesh geometry={nodes.light_light3001_0.geometry} material={materials['light3.001']} rotation={[-Math.PI / 2, 0, 0]} />
      <mesh geometry={nodes.curtain_curtain001_0.geometry} material={materials['curtain.001']} rotation={[-Math.PI / 2, 0, 0]} />
      <mesh geometry={nodes.house_house001_0.geometry} material={materials['house.001']} rotation={[-Math.PI / 2, 0, 0]} />
      <mesh geometry={nodes.dec_dec001_0.geometry} material={materials['dec.001']} rotation={[-Math.PI / 2, 0, 0]} />
      <mesh geometry={nodes.vase_vase001_0.geometry} material={materials['vase.001']} rotation={[-Math.PI / 2, 0, 0]} />
      <mesh geometry={nodes.lamp_lamp1001_0.geometry} material={materials['lamp1.001']} rotation={[-Math.PI / 2, 0, 0]} />
      <mesh geometry={nodes.lamp_lamp2001_0.geometry} material={materials['lamp2.001']} rotation={[-Math.PI / 2, 0, 0]} />
      <mesh geometry={nodes.Plastic_pot_Plastic_pot001_0.geometry} material={materials['Plastic_pot.001']} rotation={[-Math.PI / 2, 0, 0]} />
      <mesh geometry={nodes.plants_plants001_0.geometry} material={materials['plants.001']} position={[-1.791, 0.723, 4.242]} rotation={[-Math.PI / 2, 0, -0.396]} scale={[3.279, 3.279, 4.858]} />
      <mesh geometry={nodes.pillow_pillow1001_0.geometry} material={materials['pillow1.001']} rotation={[-Math.PI / 2, 0, 0]} />
    </group>
  )
}

useGLTF.preload('/vintage_living_room-transformed.glb')
